export default __webpack_public_path__ + "static/media/22-reconfigure-your-firewall.41151461.jpg";